import React from 'react';
import './Skills.css'

const Skills = () => {
    return (
        <div className="container m-3">
            <h4>Skills</h4>
            <hr style={{width: '7%',height: '2px', color:'blue'}}/>
            <div className="row">
                <div className="col-md-5">
                    <div className="m-2 skill-progress">
                        <div className="d-flex"><h6>HTML/CSS</h6>
                        <small className="ms-auto">95%</small>
                        </div>
                    
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "95%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>JavaScript</h6>
                        <small className="ms-auto">80%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "80%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2  skill-progress">
                    <div className="d-flex"><h6>React js</h6>
                        <small className="ms-auto">75%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "75%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>Material UI</h6>
                        <small className="ms-auto">90%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "90%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>Express js</h6>
                        <small className="ms-auto">60%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "60%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>Bootstrap</h6>
                        <small className="ms-auto">90%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "90%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>ES6</h6>
                        <small className="ms-auto">80%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "80%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>Tailwind CSS</h6>
                        <small className="ms-auto">90%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "90%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>Node.js</h6>
                        <small className="ms-auto">70%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "70%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                    <div className="m-2 skill-progress">
                    <div className="d-flex"><h6>MongoDB</h6>
                        <small className="ms-auto">85%</small>
                        </div>
                    <div class="progress bar" >
                        <div class="progress-bar align-self-center" role="progressbar" style={{width: "85%",height: "5px",padding:"5px",borderRadius: "10px"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default Skills;